module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-ae856d0bb0066d32326fa57e52ff8e72.png";